import gql from "graphql-tag";
import { Nullable } from "global";

export const GET_INTERNAL_TIERS = gql`
  query GetInternalTiers($accountId: ID!) {
    tiers: financePrograms(accountId: $accountId, structure: INTERNAL_CREDIT_TIERS) {
      accountId
      id: financeProgramId
      structure
      createdDateTime
      modifiedDateTime
      prescreenCriteria {
        active
        accountId
        jsonCriteria
        id: prescreenCriteriaId
      }
    }
  }
`;

export interface TierResponse {
  tiers: {
    id: string;
    accountId: string;
    createdDateTime: string;
    modifiedDateTime: string;
    structure: "INTERNAL_CREDIT_TIERS";
    prescreenCriteria: {
      id: string;
      active: boolean;
      accountId: string;
      jsonCriteria: Record<string, any>;
    };
  }[];
}

export interface TierVariables {
  accountId: string;
}

export const CREATE_INTERNAL_TIERS = gql`
  mutation CreateInternalTiers($input: CreateFinanceProgramInput!) {
    createFinanceProgram(input: $input) {
      financeProgramId
    }
  }
`;

export const UPDATE_CRITERIA_STATUS = gql`
  mutation UpdateCriteriaStatus($input: UpdateFinanceProgramInput!) {
    updateFinanceProgram(input: $input) {
      nameInternal
    }
  }
`;

export const UPDATE_INTERNAL_TIERS = gql`
  mutation UpdateInternalTiers($input: UpdatePrescreenCriteriaInput!) {
    updatePrescreenCriteria(input: $input) {
      prescreenCriteriaId
    }
  }
`;

export interface TierCreateOrUpdateResponse {}

export interface UpdateCriteriaStatusResponse {}

export interface UpdateCriteriaStatusVariables {
  input: {
    active: boolean;
    financeProgramId: string;
  };
}

export interface TierJSONCriteria {
  name: string;
  color: string;
  formRules: Record<string, any>[];
  jsonRules: {
    conditions: {
      all: any[];
    };
  };
}

export interface TierCreateVariables {
  input: {
    accountId: string;
    nameInternal: string;
    validDateEnd: null;
    validDateStart: null;
    structure: "INTERNAL_CREDIT_TIERS";
    financeProgramModificationSettings: { markup: false };
    prescreenCriteriaInput: {
      name: string;
      notes: Nullable<string>;
      accountId: string;
      guidelines: Nullable<string>;
      lenderProfileIdsToLink: any[];
      financeProgramIdsToLink: any[];
      jsonCriteria: TierJSONCriteria[];
    };
  };
}

export interface TierUpdateVariables {
  input: {
    prescreenCriteriaId: string;
    accountId: string;
    jsonCriteria: TierJSONCriteria[];
  };
}
